import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

import { IS_LOCAL_ENV } from '@gto/helpers/env-checkers'

import type { RouterContext } from '@/router'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  wrapInSuspense: true,
  pendingMinMs: 0,
})

function Root() {
  return (
    <>
      <HeadContent />
      <Outlet />
      {IS_LOCAL_ENV() && <TanStackRouterDevtools />}
    </>
  )
}
